import React, { useState, useContext } from 'react'
import { useListRepository, SimpleDialog, AuthContext } from 'elentari'
import documentosRepository from './DocumentosRepository'
import {
  Typography,
  Grid,
  CircularProgress,
  Fab,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import DeleteIcon from '@material-ui/icons/Delete'

const DocumentosList = ({ match, cannotUpdate, onClickNew }) => {
  const { user } = useContext(AuthContext)
  const [dialog, setDialog] = useState({
    open: false,
    item: null
  })
  const listHook = useListRepository({
    repository: documentosRepository,
    defaultSort: 'createdAt',
    path: `solicitacoes/${match.params.id}/documentos`,
    query: [['solicitacaoId', match.params.id]],
    forceRemove: true
  })

  delete listHook.undoRemove
  listHook.deleteFItem = listHook.removeItem
  delete listHook.removeItem

  const handleClickDeleteFConfirmation = async () => {
    if (dialog.item) {
      await listHook.deleteFItem(dialog.item)
    }
  }

  const renderList = list => {
    return list.length ? (
      <Grid item xs={12}>
        <List>
          {list.map(item => (
            <ListItem key={item.id}>
              <ListItemText
                primary={item.descricao}
                secondary={item.fileName}
              />
              <ListItemSecondaryAction>
                <IconButton
                  title="Abrir"
                  variant="contained"
                  onClick={() => window.open(item.fileURL)}
                >
                  <OpenInNewIcon />
                </IconButton>
                <div
                  style={{ display: 'inline-block' }}
                  hidden={user.realm !== 'admin'}
                >
                  <IconButton
                    aria-label="delete"
                    disabled={cannotUpdate}
                    onClick={() => setDialog({ open: true, item: item })}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Grid>
    ) : (
      <Grid item xs={12} sm={2}>
        <Typography variant="body" gutterBottom>
          Nenhum Documento
        </Typography>
      </Grid>
    )
  }

  return (
    <>
      <Grid container alignItems="center" justifyContent="center" spacing={3}>
        <Grid item xs={12} sm={11}>
          <Typography variant="h6" gutterBottom>
            Lista de Documentos
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <Grid container direction="row" justifyContent="flex-end">
            <Fab
              aria-label="Adicionar"
              color="primary"
              disabled={cannotUpdate}
              onClick={onClickNew}
              size="small"
            >
              <AddIcon size={24} color="inherit" />
            </Fab>
          </Grid>
        </Grid>
        {listHook.state.loading ? (
          <Grid item xs={12} sm={1}>
            <CircularProgress />
          </Grid>
        ) : (
          renderList(listHook.state.list)
        )}
      </Grid>
      <SimpleDialog
        open={dialog.open}
        buttonLabel="Não"
        handleClose={() => setDialog({ open: false })}
        primaryAction={handleClickDeleteFConfirmation}
        title="Excluir permanentemente esse arquivo?"
        primaryActionButtonLabel="Sim"
      />
    </>
  )
}
export default React.memo(DocumentosList)
